import type { RhinoRating } from '../..';
import { tvpil } from '../../data/compat/tvpil';
import { KalturaAsset } from '../objects';

/**
 * @see https://kaltura.atlassian.net/wiki/spaces/KUXDEV/pages/3613229074/Rating+Spec#TVPIL-Task
 */
export function getRating(asset: { metas: KalturaAsset['metas'] }): RhinoRating | undefined {
  const rating = tvpil.availableRatings.find((r) => {
    const metaValue = asset.metas[r.name]?.value;

    return metaValue && parseInt(metaValue as string) > -1;
  });

  if (!rating) {
    return undefined;
  }

  return {
    name: rating.name,
    value: asset.metas[rating.name]?.value as string,
  };
}

export function getProviderNameFromMeta(metas: KalturaAsset['metas']) {
  const providerNames = Object.keys(tvpil.providers);

  for (let i = 0; i < providerNames.length; i++) {
    const provider = tvpil.providers[providerNames[i]];

    const assetProvider = (metas[provider.metaKey]?.value as unknown as string)?.toLowerCase();

    if (assetProvider === provider.metaValue?.toLowerCase()) {
      return providerNames[i];
    }
  }
}
